// extracted by mini-css-extract-plugin
export default {"title":"DuplicateClientAllocation_title__WI+xE"};